import { Container } from "@mui/material";
import { apiGetInstallment } from "api/installmentApi";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../store/store";
import Header from "../list/header";
import Table from "components/Table";
import { installmentsShowTable } from "./tableConfig";
import { setTableData } from "../../../store/actions/dataTableAction";

type Props = {};

const InstallmentShow = (props: Props) => {
  const dispatch = useDispatch();
  const store = useAppSelector((x) => x);
  const token = store.businessReducer.business.token;
  const { id } = useParams();
  const [installmentInitialData, setInstallmentInitialData] = useState<any>({});
  const initialData = async (status: string) => {
    dispatch(
      //@ts-ignore
      apiGetInstallment(id, token, (data: any, response) => {
        setInstallmentInitialData(data);
        const items = data?.Installment_Items?.map((x: any) => { return { ...x, installmentType: data.type } })
        dispatch(setTableData(items, null, response.data.sumAmount));
      }, status)
    );
  };

  useEffect(() => {
    initialData("");

    return () => { };
  }, [id]);
  const tabCahnged = (key: string) => {
    initialData(key)
  }
  return (
    <Container maxWidth="lg">
      <div className="my-10">
        <Header
          showButton={false}
          title={installmentInitialData.description}
          subTitle={
            <div className="flex flex-row items-center justify-start gap-1">
              <span className="text-black text-sm font-IRANSans font-medium">
                {installmentInitialData?.payer?.accountingCode ?? ""}
              </span>
              <span className="px-2 py-[1px] bg-[#D6E4FF] text-blue-1 rounded font-IRANSans font-xs text-xs">
                #
              </span>
              <span className="text-[#424242] text-xs font-IRANSans font-normal">
                {installmentInitialData.payer_type === "factor"
                  ? installmentInitialData.payer?.Person?.nickName ?? ""
                  : installmentInitialData?.payer?.nickName ?? ""}
              </span>
            </div>
          }
        />
      </div>
      <div className="bg-white rounded-md pb-1">
        <Table disablePagination sumAmountInfo={[
          { name: "pay", isCurrency: true },
          { name: "remain", isCurrency: true },
        ]
        } disableDateFilter={true} onTabChange={(options: any) => {
          tabCahnged(options.activeTab.key === "installmentShow" ? "" : options.activeTab.key)
        }} tabs={installmentsShowTable} />
      </div>
      {/* <Footer
        currency={installmentInitialData.Currency?.fa_title ?? ""}
        remaining={installmentInitialData?.remaining ?? 0}
        payed={installmentInitialData?.payed ?? 0}
        totalPrice={installmentInitialData?.totalPaid ?? 0}
      /> */}
    </Container>
  );
};

export default InstallmentShow;
